import { onMounted, ref } from "vue";
import { defineStore } from "pinia";
import { getProfileList, setDefaultProfile } from "~/api/user";

export const useBaziFileStore = defineStore(
	"baziFile",
	() => {
		const baziFileList = ref([]);
		// 选择的八字档案
		const baziFile = ref({});

		// 记录列表是否获取完（不持久化，刷新后需重新请求）
		const isGetFileList = ref(false);
		// 获取档案列表
		const getbaziFileList = async () => {
			isGetFileList.value = false;
			const res = await getProfileList();
			baziFileList.value = res.data.list;
			baziFile.value = baziFileList.value.find(item => item.is_default === 1);
			isGetFileList.value = true;
			return Promise.resolve(res);
		};

		onMounted(() => {
			if (!import.meta.client) return;
			if (!localStorage.getItem("token")) return;
			getbaziFileList();
		});

		const setFile = async file => {
			await setDefaultProfile({ mess_id: file.id });
			baziFileList.value = baziFileList.value.map(item => ({
				...item,
				is_default: item.id === file.id ? 1 : 0,
			}));
			baziFile.value = { ...file, is_default: 1 };
		};

		// 重置store状态
		const resetBaziStore = () => {
			baziFileList.value = [];
			baziFile.value = {};
			isGetFileList.value = false;
		};

		return {
			baziFile,
			baziFileList,
			isGetFileList,
			setFile,
			getbaziFileList,
			resetBaziStore,
		};
	},
	{
		persist: {
			// 不持久化 isGetFileList，否则刷新后会跳过档案列表请求
			paths: ["baziFile", "baziFileList"],
			storage: import.meta.client ? localStorage : undefined,
		},
	}
);
